import { render, staticRenderFns } from "./OrgPicker.vue?vue&type=template&id=2240e276&scoped=true"
import script from "./OrgPicker.vue?vue&type=script&lang=js"
export * from "./OrgPicker.vue?vue&type=script&lang=js"
import style0 from "./OrgPicker.vue?vue&type=style&index=0&id=2240e276&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240e276",
  null
  
)

export default component.exports